/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Project_Import_ButtonInputs */

const en_project_import_button = /** @type {(inputs: Project_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Import Project`)
};

const fr_project_import_button = /** @type {(inputs: Project_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importer le projet`)
};

const de_project_import_button = /** @type {(inputs: Project_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importprojekt`)
};

const it_project_import_button = /** @type {(inputs: Project_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Importa progetto`)
};

const ru_project_import_button = /** @type {(inputs: Project_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Импортный проект`)
};

const es_project_import_button = /** @type {(inputs: Project_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proyecto de importación`)
};

const zh_cn2_project_import_button = /** @type {(inputs: Project_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`导入项目`)
};

const ja_project_import_button = /** @type {(inputs: Project_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`プロジェクトのインポート`)
};

const hi_project_import_button = /** @type {(inputs: Project_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`आयात परियोजना`)
};

const pt_pt2_project_import_button = /** @type {(inputs: Project_Import_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Projeto de Importação`)
};

/**
* | output |
* | --- |
* | "Import Project" |
*
* @param {Project_Import_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const project_import_button = /** @type {((inputs?: Project_Import_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Import_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_project_import_button(inputs)
	if (locale === "de") return de_project_import_button(inputs)
	if (locale === "it") return it_project_import_button(inputs)
	if (locale === "ru") return ru_project_import_button(inputs)
	if (locale === "es") return es_project_import_button(inputs)
	if (locale === "zh-CN") return zh_cn2_project_import_button(inputs)
	if (locale === "ja") return ja_project_import_button(inputs)
	if (locale === "hi") return hi_project_import_button(inputs)
	if (locale === "pt-PT") return pt_pt2_project_import_button(inputs)
	return en_project_import_button(inputs)
});